import { Highlighted } from '../../search'

function ResultRow({ result, onOpenPage }) {
  return (
    <li className="pdfsearch-result">
      <button type="button" className="pdfsearch-result-head" onClick={() => onOpenPage(result.page)}>
        <span className="pdfsearch-result-page">p.{result.page}</span>
        <span className="pdfsearch-result-count">
          {result.matchCount} match{result.matchCount === 1 ? '' : 'es'}
        </span>
      </button>

      <div className="pdfsearch-snippets">
        {result.snippets.map((snippet, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <p className="pdfsearch-snippet" key={i}>
            <Highlighted text={snippet.text} matches={snippet.matches} />
          </p>
        ))}
      </div>
    </li>
  )
}

function PdfSearchResults({ state, onOpenPage, onLoadMore }) {
  if (state.status === 'idle') {
    return <div className="pdfsearch-status">Add rules and run to search this document.</div>
  }
  if (state.status === 'loading') {
    return <div className="pdfsearch-status">Searching…</div>
  }
  if (state.status === 'error') {
    return <div className="pdfsearch-status">{state.error || 'Search failed.'}</div>
  }
  if (!state.results.length) {
    return <div className="pdfsearch-status">No matches.</div>
  }

  return (
    <div className="pdfsearch-results">
      <ul className="pdfsearch-results-list">
        {state.results.map((result) => (
          <ResultRow key={result.page} result={result} onOpenPage={onOpenPage} />
        ))}
      </ul>
      {state.hasMore ? (
        <button
          type="button"
          className="pdfsearch-load-more"
          onClick={onLoadMore}
          disabled={state.loadingMore}
        >
          {state.loadingMore ? 'Loading…' : 'Load more'}
        </button>
      ) : null}
    </div>
  )
}

export default PdfSearchResults
